export default {"src":"/_next/static/media/truck-icon-3.c74f7bf3.svg","height":19,"width":16,"blurWidth":0,"blurHeight":0};